import { ApolloClient } from "@apollo/client";
import { Recurso } from "lib.common/dist/CleanArch";
import { gqlErrorsMapperRecurso } from 'lib.front/dist/common/funErrorMappers';
import { ErrExterno } from "lib.common/dist/errorHandler";
import { ProductosDtSource } from "../../bussines/dataSources/ProductosDtSource";
import { Producto } from "../../bussines/entities/Productos.entity";
import { getAllProductosGql } from "../../utils/gql/productosGql";

export class ProductosDtSourceImplGql implements ProductosDtSource {
    private apolloClient: ApolloClient<object>;
    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }
    async getAllProductos(): Promise<Recurso<Producto[]>> {
        try {

            const response = await this.apolloClient.query({
                query: getAllProductosGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<Producto[]>(response.errors);
            return errorRecurso ?? Recurso.fromData<Producto[]>(response.data.productos);
        } catch (error) {
            return Recurso.fromError<Producto[]>(new ErrExterno(error as Error));
        }
    }

}